import { BaseDataService } from './BaseDataService';
import { ScoreType, SurveyVersion } from '../../models';
import { NotificationService } from '../../services';

export class ScoreTypeDataService extends BaseDataService<ScoreType> {
    constructor(notificationService: NotificationService) {
        super('ScoreType', 'ScoreTypes', notificationService);
    }

    public getAllBySurveyVersion(surveyVersion: SurveyVersion): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurveyversion/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving score types.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/api/ScoreTypeData.tsx